<template>

    <div class="wrapper -registro">

        <section class="intro column-center">

            <h1 class="big-title column-center">
                <span>A Jaén. A tu paraíso</span>
            </h1>

        </section>

        <section class="contenedor-formulario container">

            <h2>Formulario de inscripción</h2>

            <h3>{{$route.query.name}}</h3>

            <!-- <h3 class="hora">{{dateinfo}}</h3> -->
            <h4 class="hora">{{$route.query.hour | fecha}}</h4>


            <form action="" @submit.prevent="validateBeforeSubmit">



                <legend>Titular de la reserva</legend>

                <div class="contenedor-input">
                    <label for="nombre">Nombre y Apellidos*</label>
                    <input type="text" v-model="data.name" v-validate="'required'" name="name" id="nombre"
                        @keyup="data.participant[0].name = data.name">
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('name')
                        }}</span>
                </div>

                <div class="contenedor-input">
                    <label for="dni">DNI*</label>
                    <input type="text" v-model="data.dni" v-validate="'required'" name="dni" id="dni"
                        @keyup="data.participant[0].dni = data.dni">
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('dni')
                        }}</span>
                </div>

                <div class="contenedor-input">
                    <label for="telefono">Teléfono*</label>
                    <input type="text" v-model="data.phone" v-validate="'required'" name="phone" id="telefono">
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('phone')
                        }}</span>
                </div>

                <div class="contenedor-input">
                    <label for="email">Correo Electrónico*</label>
                    <input type="email" v-model="data.email" v-validate="'required|email'" name="email" id="email">
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email')
                        }}</span>
                </div>

                <div class="contenedor-input">
                    <label for="localidad">Localidad de Procedencia*</label>
                    <input type="text" v-model="data.city" v-validate="'required'" name="city" id="localidad">
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
                        errors.first('city')}}</span>
                </div>

                <div class="contenedor-input">
                    <label for="cp">Código postal*</label>
                    <input type="text" v-model="data.cp" v-validate="'required'" name="cp" id="cp">
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
                        errors.first('cp')}}</span>
                </div>

                <div class="contenedor-radios">
                    <h4>¿Ha reservado algún alojamiento para realizar esta actividad?</h4>
                    <div class="radio">
                        <input type="radio" :value="true" v-model="data.accommodation" :id="'accommodation-true'"
                            v-validate="'required'" name="accommodation">
                        <label :for="'accommodation-true'">
                            Sí
                        </label>
                    </div>

                    <div class="radio">
                        <input type="radio" :value="false" v-validate="'required'" name="accommodation"
                            v-model="data.accommodation" :id="'accommodation-false'">
                        <label :for="'accommodation-false'">
                            No
                        </label>
                    </div>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
                        errors.first('cp')}}</span>
                </div>


                <div class="contenedor-radios" v-if="$route.query.bus == 1">
                    <h4>¿Van a desplazarse en el autobús que incluye la actividad?</h4>
                    <div class="radio">
                        <input type="radio" :value="true" v-model="data.bus" :id="'bus-true'"
                            v-validate="'required'" name="bus">
                        <label :for="'bus-true'">
                            Sí
                        </label>
                    </div>

                    <div class="radio">
                        <input type="radio" :value="false" v-validate="'required'" name="bus"
                            v-model="data.bus" :id="'bus-false'">
                        <label :for="'bus-false'">
                            No
                        </label>
                    </div>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
                        errors.first('cp')}}</span>
                </div>



                <legend>Datos de los participantes</legend>

                <div class="persona" v-for="(el,key) in data.participant">

                    <div class="contenedor-input">
                        <label :for="`nombre-participante-${key}`">Nombre y Apellidos</label>
                        <input type="text" v-model="el.name" :id="`nombre-participante-${key}`">
                    </div>

                    <div class="contenedor-input">
                        <label :for="`dni-participante-${key}`">DNI*</label>
                        <input type="text" v-validate="'required'" v-model="el.dni" :name="'dni-user-'+key" :id="`dni-participante-${key}`">
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
                            errors.first('dni-user-'+key)
                            }}</span>
                    </div>

                    <div class="contenedor-check">
                        <input type="checkbox" :id="'handicap-'+key" name="handicap" v-model="el.handicap"
                            @change="el.handicap_text = ''">
                        <label :for="'handicap-'+key">Presenta alguna limitación de movilidad</label>
                    </div>

                    <div class="contenedor-input" v-if="el.handicap">
                        <label for="">Limitación de movilidad</label>
                        <input type="text" v-model="el.handicap_text">
                    </div>

                    <a @click="eraseParticipant(el.name)" class="erase-persona" v-if="key != 0">Eliminar</a>

                </div>

                <a class="add-persona" @click="addParticipant" v-if="data.participant.length < 4">+ Añadir
                    participante</a>






                <div class="contenedor-check">
                    <input type="checkbox" id="politica" name="politica" v-validate="'required'"
                        v-model="data.politica">
                    <label for="politica">He leido y acepto la <a href="https://www.jaenparaisointerior.es/web/jaen-paraiso-interior/politica-privacidad">política de privacidad</a></label>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica')
                        }}</span>
                </div>

                <div class="contenedor-check">
                    <input type="checkbox" id="inscripcion" name="inscripcion" v-validate="'required'"
                        v-model="data.inscription">
                    <label for="inscripcion">Si deseo que Diputación Provincial de Jaén utilice mis datos para la
                        gestión de la inscripción en las actividades.</label>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('inscripcion')
                        }}</span>
                </div>

                <div class="contenedor-check">
                    <input type="checkbox" id="interes" name="interes" v-model="data.interes">
                    <label for="interes">Si deseo que Diputación Provincial de Jaén utilice mis datos para información
                        de futuras actividades de interés turístico de la provincia.</label>
                    <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('interes')
                        }}</span>
                </div>

                <button class="btn-skull -green" :loading="loading" v-if="showbtn">Inscribirme</button>

                <p>Los interesados en participar en las actividades programadas podrán solicitar inscripción en un
                    máximo de dos actividades por semana, que en el caso de coincidir en el mismo día, obligatoriamente,
                    una se desarrollará en horario de mañana, y otra en el de tarde.</p>
                 
                <p>El plazo de presentación de solicitudes de inscripción para cada una de las actividades, finaliza 24
                    horas antes de su realización, salvo en el caso de actividades programadas en sábado o domingo, en
                    cuyo caso concluye a las 12 horas del viernes anterior.</p>

                <p>Después de inscribirte recibirás un correo informando que la solicitud ha sido recibida pero el
                    proceso de inscripción no finaliza hasta que recibas un segundo correo confirmando que hay plazas
                    disponibles. Las inscripciones se atenderán por orden de llegada hasta completar aforo.</p>

            </form>

            {{error}}

            <div class="contenedor-popup" v-if="sending">
                <div class="popup">
                    <h2 v-if="!error">Enhorabuena</h2>
                    <p v-if="!error">Te has inscrito correctamente</p>
                    <p v-if="error">
                        <template v-if="error == '0'">Esta actividad no está disponible</template>
                        <template v-if="error == '1'">Esta actividad ya está llena</template>
                        <template v-if="error == '2'">Ya estás apuntado a esta actividad</template>
                    </p>
                    <a class="btn green" @click="sending = false">Aceptar</a>
                </div>
            </div>

        </section>

    </div>

</template>

<script>

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';

    Vue.use(VeeValidate);

    import { mapGetters, mapActions } from 'vuex'

    import moment from 'moment';

    export default {
        name: 'registro',
        mounted() {
            this.data.dateid = this.$route.query.dateid;
        },
        data: () => ({
            data: {
                name: "",
                phone: "",
                dni: "",
                email: "",
                city: "",
                cp: '',
                accommodation: null,
                bus: null,
                newsletter: false,
                politica: false,
                inscription: false,
                interes: false,
                dateid: '',
                participant: [
                    {
                        name: '',
                        dni: '',
                        age: '',
                        handicap: false,
                        handicap_text: '',
                    }
                ]

            },
            clicked: false,
            loading: false,
            sending: false,
            error: null,
            showbtn: true
        }),
        methods: {
            ...mapActions(['sendRegistro']),
            validateBeforeSubmit: function () {
                this.clicked = true;
                this.$validator.validateAll().then(canSend => {
                    if (canSend) {
                        this.loading = true;
                        this.data.newsletter = (this.data.politica && this.data.inscription && this.data.interes);
                        this.sendRegistro(this.data).then(r => {
                            this.loading = false;
                            this.showbtn = false;
                            if (r.status == true) {
                                this.sending = true;
                            } else {
                                this.sending = true;
                                this.error = r.error;
                            }
                        })

                    } else {
                        setTimeout(() => {
                            $("html, body").animate({ scrollTop: $("*[aria-invalid=true]").eq(0).offset().top - 150 }, 1000);
                        }, 300);
                    }
                });
            },
            addParticipant() {
                let participant = {
                    name: '',
                    dni: '',
                    age: '',
                    handicap: false,
                    handicap_text: '',
                };

                this.data.participant.push(participant);
            },
            eraseParticipant(nombre) {
                this.data.participant = this.data.participant.filter(e => (e.name != nombre))
            }
        },
        computed: {
            dateinfo() {
                let date = this.$route.query.date.split("-");
                date = `${date[2]}-${date[1]}-${date[0]}`;
                return date;
            },
        },
        filters: {
            parseHour(value) {
                let hora = value.split(" ").pop();
                return hora;
            },
            fecha(value) {
                moment.locale('es');
                return moment(value).format('D MMMM YYYY, h:mm');
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/views/registro.vue